import * as yup from 'yup'

export const apiStrengthSchema = yup.object().shape({
  api_name: yup.string().required('API is required'),
  strength: yup.string().required('Strength is required'),
  unit: yup.string().required('Unit is required')
})

export const productSchema = yup.object().shape({
  brand_name: yup.string().required('Brand name is required'),
  cold_chain: yup.boolean().required(),
  inventory_unit: yup.string().required('UoM is required'),

  controlled_substance: yup.boolean().required(),

  dosage_form: yup.string().required('Dosage form is required'),

  generic_name: yup.string().required('Generic name is required'),

  is_active: yup.boolean().required(),

  mark_up_percentage: yup.string(),

  max_temp: yup.string().when('cold_chain', {
    is: true,
    otherwise: schema => schema.notRequired(),
    then: schema => schema.required('Maximum temperature is required when cold chain is enabled')
  }),

  min_temp: yup
    .string()

    .when('cold_chain', {
      is: true,
      otherwise: schema => schema.notRequired(),
      then: schema => schema.required('Minimum temperature is required when cold chain is enabled')
    }),

  product_image: yup.string().notRequired(),

  product_image_signed_id: yup.string().notRequired(),

  route: yup.string().required('Route is required'),

  storage_condition: yup.string().required('Storage condition is required'),

  therapeutic_category: yup.string().required('Therapeutic category is required'),

  vaccine: yup.boolean(),

  vaccine_antigen_type: yup.string(),

  vaccine_presentation_type: yup.string(),
  vat_percentage: yup.string().notRequired()
})

export const productInventorySchema = yup.object().shape({
  batch_number: yup.string().required('Batch number is required'),
  date_of_manufacture: yup.string().required('Manufacture date is required'),
  expiry_date: yup.string().required('Expiry date is required'),
  facility: yup.string().required('Facility is required'),
  stock_location: yup.string().required('Location is required'),
  inventory_location: yup.string().required('Inventory location is required'),
  api_strengths: yup
    .array()
    .of(apiStrengthSchema)
    .min(1, 'At least one API strength is required')
    .required('API strengths are required'),

  nafdac_number: yup.string().required('NAFDAC number is required'),

  quantity_received: yup
    .number()
    .typeError('Please enter a valid quantity using numbers only')
    .required('Quantity received is required')
    .min(1, 'Quantity must be at least 1'),

  selling_price: yup.string(),
  packaging: yup.string().required('Packaging is required'),
  inventory_unit: yup.string().required('UoM is required'),
  pack_quantity: yup.string().required('Pack Quantity is required'),
  pack_content_unit: yup.string().required('Pack content unit is required'),

  stock_quantity: yup.number().optional(),

  unit_cost: yup.string()
})

export const REQUIRED_PRODUCT_FIELDS = [
  'generic_name',
  'brand_name',
  'dosage_form',
  'route',
  'therapeutic_category',
  'storage_condition',
  'cold_chain',
  'inventory_unit',
  'controlled_substance',
  'is_active'
]
